import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const BrandingContext = createContext(null);
export const useBranding = () =>
  useContext(BrandingContext) || { branding: null, refreshBranding: () => {} };

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(null);

  const refreshBranding = useCallback(() => {
    api.get("/branding")
      .then((r) => setBranding(r.data))
      .catch(() => setBranding({ logo: null, company_name: "SYMIN" }));
  }, []);

  useEffect(() => { refreshBranding(); }, [refreshBranding]);

  return (
    <BrandingContext.Provider value={{ branding, refreshBranding }}>
      {children}
    </BrandingContext.Provider>
  );
}
